export const TASK_LIST = 'task/task/'
export const TASK_DETAIL = 'task/task/{id}'
